import { FolderPlansWidgetStore } from './folder-plans-widget.store';
import { Component, computed, inject, input } from '@angular/core';
import { TableComponent } from '../../../../modules/shared/components/kit/table/table.component';
import {
    TableColumn,
    TableColumnOffersLayout,
    TableColumnType,
} from '../../../../modules/shared/components/kit/table/table.types';
import { dateTimeField, dayField, offersField, userChipField } from '../../../../modules/shared/components/kit/table/table.fields';
import { UserChipRenderTypeEnum } from '../../../kit/user-chip/user-chip.component.types';
import { FilterBuilder } from '@libs/shared/utils/grid.builder';
import { Operator } from '../../../../../../../data-grid/src/grid/grid-request.dto';

@Component({
    selector: 'app-folder-plans-widget',
    templateUrl: './folder-plans-widget.component.html',
    styleUrl: './folder-plans-widget.component.scss',
    providers: [FolderPlansWidgetStore],
    imports: [
        TableComponent,
    ],
})
export class FolderPlansWidgetComponent {
    protected readonly store = inject(FolderPlansWidgetStore);

    public folderId = input.required<number, string | number>({
        transform: (it) => Number(it),
    });

    protected readonly prefix = 'person.dashboard.plans.';

    protected columns: TableColumn[] = [
        dayField('day', 'dateFrom'),
        dateTimeField('dateFrom'),
        userChipField('users', UserChipRenderTypeEnum.User, {
            filterable: true,
            sortable: true,
        }),
        {
            name: 'addressTo',
            filterable: true,
            type: TableColumnType.MapLink,
        },
        offersField('offers', TableColumnOffersLayout.Vertical, {
            filterable: true,
        }),
        {
            name: 'note',
            filterable: true,
        },
    ];

    protected additionalFilter = computed(() => {
        return new FilterBuilder()
            .where('folderId', this.folderId().toString(), Operator.EQ)
            .filter().filter;
    });

    protected async detailPlan(item: any): Promise<void> {
        //await router.navigateByUrl(workUri({ workType: item.workType, id: item.id }, item.serviceId));
    }
}
